import styled from 'styled-components'

const WrapPopupDeviceInfos = styled.div`
    filter: drop-shadow(0px 4px 8px rgba(0, 0, 0, 0.1));
    border-radius: 4px;
    background: #FFFFFF;
    width: 300px;
    box-sizing: border-box;

    &:hover {
        cursor: initial;
    }

    & > * {
        padding: 0 16px;
    }

    .wrap-row {
        display: flex;
        justify-content: space-between;
        box-shadow: inset 0px -0.5px 0px rgba(0, 0, 0, 0.15);

        .wrap-row-left{
            min-height: 94px;
            display: flex;
            align-items: center;
        }
        .wrap-row-right{
            display: flex;
            align-items: flex-end;
            flex-direction: column;
            padding-top: 12px;
            position: relative;
            .icon{
                cursor: pointer;
            }
        }
        .image {
            width: 60px;
            height: 60px;
            display: flex;
            justify-content: center;
            border-radius: 50%;
            flex-shrink: 0;
            border: 1px solid ${props => props.colorByStatus || "transparent"};
            img {
                height: 100%;
            }
        }
 
        .wrap-column {
            display: flex;
            align-items: center;
            gap: 6px;
            margin-left: 13px;
            .device-icon{
                display: flex;
                align-items: center;
                gap: 6px;
            }
            .device-name {
                font-family: "Open Sans";
                font-style: normal;
                font-weight: 600;
                font-size: 15px;
                line-height: 20px;
                letter-spacing: -0.01em;
                color: #313131;
                white-space: nowrap;
                overflow: hidden;
                text-overflow: ellipsis;
                width: 100%;
            }
        }
        .device-detail{
            font-family: 'Open Sans';
            font-style: normal;
            font-weight: 400;
            font-size: 11px;
            line-height: 15px;
            letter-spacing: -0.02em;
            color: #33ADFF;
            cursor: pointer;
        }
    }

    .wrap-field {
        min-height: 44px;
        display: flex;
        justify-content: space-between;
        align-items: center;
        flex-grow: 1;

        &:not(.last-field) {
            box-shadow: inset 0px -0.5px 0px rgba(0, 0, 0, 0.15);
        }
        
        .wrap-outer-value {
            flex-grow: 1;
            min-width: 0;
            display: flex;
            justify-content: flex-end;
            align-items: center;
        }

        .field-name {
            font-family: "Open Sans";
            font-style: normal;
            font-weight: normal;
            font-size: 11px;
            line-height: 15px;
            letter-spacing: -0.02em;
            color: #777777;
            white-space: nowrap;
        }
        
        .field-value {
            margin-left: 15px;
            font-family: "Open Sans";
            font-style: normal;
            font-weight: normal;
            font-size: 13px;
            line-height: 18px;
            letter-spacing: -0.01em;
            color: #313131;
            overflow: hidden;
            white-space: nowrap;
            text-overflow: ellipsis;
            &.color-status{
                color: ${props => props.colorByStatus}
            }
            &.link{
                color: #33ADFF;
                font-weight: 400;
                font-size: 13.5px;
                line-height: 18px;
                text-align: right;
                letter-spacing: -0.01em;
                width: 100px;
            }
        }

        .map {
            margin-left: 8px;
            width: 14px;
            height: 14px;
            flex-shrink: 0;
            cursor: pointer
        }
    }
`;

export {
    WrapPopupDeviceInfos
}